import {Routes, Route, useLocation} from "react-router-dom";
import Home from "./Pages/Home/Home";
import AppBar from "./Layout/AppBar/AppBar";
import Footer from "./Layout/Footer/Footer";
import "./App.scss"
import FAQ from "./Pages/FAQ/FAQ";
import Services from "./Pages/Services/Services";
import Development from "./Pages/Services/Development/Development";
import OurWorks from "./Pages/OurWorks/OurWorks";
import WebPresentation from "./Pages/WebPresentation/WebPresentation";
import PluginPresentation from "./Pages/PluginPresentation/PluginPresentation";
import {useEffect, useState} from "react";
import Grafica from "./Pages/Services/Grafica/Grafica";
import {Client, DiscordMember, GalleryItem, urlServer, WorkItem} from "./types";
import GMinecraft from "./Pages/GMinecraft/GMinecraft";
import GLogos from "./Pages/GLogos/GLogos";
import GDrawings from "./Pages/GDrawings/GDrawings";
import Video from "./Pages/Services/Video/Video"
import GYoutube from "./Pages/GYoutube/GYoutube";
import EnderClubLoader from "./Components/EnderClubLoader/EnderClubLoader";
import YLongForm from "./Pages/YLongForm/YLongForm";
import YShortForm from "./Pages/YShortForm/YShortForm";
import i18n from "i18next";
import NotFound from "./Pages/NotFound/NotFound";
import ScrollToTop from "./Components/ScrollToTop";



function App() {
    const [loadingPercent, setLoadingPercent] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [staff, setStaff] = useState<DiscordMember[] | []>([]);
    const [workItems, setWorkItems] = useState<WorkItem[]>([]);
    const [workClients, setWorkClients] = useState<Client[]>([]);
    const [workGraphic, setWorkGraphic] = useState<GalleryItem[]>([]);
    const [showOurWorks, setShowOurWorks] = useState<boolean>(false);
    let language = localStorage.getItem('language') ?? "it";
    if ((language !== "it" && language !== "en" && language !== "es")) language = "it";
    i18n.changeLanguage(language);

    const flag: Record<string, number> = {
        "it": 0,
        "en": 1,
        "es": 2,
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [staffRes, shortsRes, clientsRes, graphicRes] = await Promise.all([
                    fetch(`${urlServer}api/discord/staff`),
                    fetch(`${urlServer}api/works/shorts`),
                    fetch(`${urlServer}api/works/clients`),
                    fetch(`${urlServer}api/works/graphic`)
                ]);

                if (!staffRes.ok || !shortsRes.ok || !clientsRes.ok || !graphicRes.ok) {
                    throw new Error('Errore nel caricamento di una o più risorse');
                }

                const staffData = await staffRes.json();
                const shortsData = await shortsRes.json();
                const clientsData = await clientsRes.json();
                const graphicData = await graphicRes.json();

                // Formattazione shorts
                const items = shortsData.result.map((entry: any) => ({
                    title: entry.channel,
                    server: entry.channel,
                    views: entry.views,
                    href: entry.url,
                    thumbnail: entry.thumbnail,
                    podium: entry.podium,
                    video: entry.video,
                }));

                if((staffData.allStaff.length > 0) || (items.length > 0) || (clientsData.clients.length > 0) || (graphicData.graphics.length > 0)) {
                    setShowOurWorks(true)
                } else {
                    setShowOurWorks(false)
                }

                // Salvataggio negli stati
                setStaff(staffData.allStaff || []);
                setWorkItems(items);
                setWorkClients(clientsData.clients || []);
                setWorkGraphic(graphicData.graphics || []);

            } catch (error) {
                console.error('Errore durante il fetch dei dati:', error);
            } finally {
                setLoadingPercent(100);
                setTimeout(() => {
                    setLoading(false)
                }, 2000);
            }
        };

        fetchData();
    }, []);

    if(loading) {
        return <EnderClubLoader value={loadingPercent} />;
    }



  return (
      <>
        <AppBar showOurWorks={showOurWorks} numberFlag={flag[language]} />
          {/*<AIAssistant/>*/}
          <div className="space-appbar"/>
          <ScrollToTop />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="servizi" element={<Services />} />
            <Route path="servizi/video" element={<Video />} />
            <Route path="servizi/video/short-form" element={<YShortForm staff={staff} workItems={workItems} />} />
            <Route path="servizi/video/long-form" element={<YLongForm staff={staff} workVideo={workItems} />} />

            <Route path="servizi/grafica" element={<Grafica />} />
            <Route path="servizi/grafica/youtube-thumbnail" element={<GYoutube staff={staff} workGraphic={workGraphic} />} />
            <Route path="servizi/grafica/minecraft" element={<GMinecraft staff={staff} workGraphic={workGraphic} />} />
            <Route path="servizi/grafica/logos" element={<GLogos staff={staff} workGraphic={workGraphic} />} />
            <Route path="servizi/grafica/drawings" element={<GDrawings staff={staff} workGraphic={workGraphic} />} />

            <Route path="servizi/development" element={<Development />} />
            <Route path="servizi/development/minecraft" element={<PluginPresentation staff={staff} />} />
            <Route path="servizi/development/web" element={<WebPresentation staff={staff} />} />

            <Route path="lavori" element={<OurWorks workClients={workClients} workItems={workItems} workGraphic={workGraphic} />} />


          <Route path="/faq" element={<FAQ />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer/>
      </>
  );
}

export default App;
